<template>
<div id="timer">
	<div class="tm" v-if="this.times">
		<span>{{label}}</span>
	</div>
</div>
</template>

<style scoped lang="sass">

</style>

<script>
import {
	mapState
} from 'vuex';

export default {
	name: 'timer',
	props: {
		time: Number
	},
	data : function(){
		return {
			times : 0,
			interval : null
		}
	},
	computed: mapState({
		auth: state => state.auth,
		label : function(){
			return (this.times / 1000).toFixed(0) + 's'
		}
	}),

	created(){
		this.times = this.time
		
		this.interval = setInterval(() => {
			this.times = this.times - 1000

			if(this.times < 0){
				this.times = 0
			}

		}, 1000)
    },

	beforeDestroy(){
		if(this.interval){
			clearInterval(this.interval)
			this.interval = null
		}
    },

	methods: {

	},
}
</script>
